// These must stay in sync with $width-side-panel-small,
// $width-side-panel-enlarged, and $breakpoint-side-panel
// in src/styles/variables/general.scss.
//
// Lifted out of CSS Modules :export because Lightning CSS
// (Turbopack's CSS engine in Next 16) doesn't surface those
// exports at runtime, which collapsed listing-card rendering
// in the search side panel.
export const SIDE_PANEL_WIDTH_SMALL = 310;
export const SIDE_PANEL_WIDTH_ENLARGED = 605;
export const SIDE_PANEL_BREAKPOINT = 1199;
